export var Dedications = [
  {
    id: 48,
    label_czech: "Andělé strážní",
    label_czech_2: null,
    label_english: "Guardian Angels",
    aggregation_level2: "angel/s",
    aggregation_level1: "angel/s",
  },
  {
    id: 49,
    label_czech: "sv. Archanděl Michael",
    label_czech_2: null,
    label_english: "St. Michael the Archangel",
    aggregation_level2: "angel/s",
    aggregation_level1: "angel/s",
  },
  {
    id: 35,
    label_czech: "Boží Tělo",
    label_czech_2: null,
    label_english: "Corpus Christi",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 36,
    label_czech: "Božího Milosrdenství",
    label_czech_2: null,
    label_english: "Divine Mercy",
    aggregation_level2: "God",
    aggregation_level1: "God",
  },
  {
    id: 39,
    label_czech: "ke cti Boží",
    label_czech_2: null,
    label_english: "Glory of God",
    aggregation_level2: "God",
    aggregation_level1: "God",
  },
  {
    id: 43,
    label_czech: "Spasitel",
    label_czech_2: null,
    label_english: "Holy Saviour",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 47,
    label_czech: "sv. Duch",
    label_czech_2: null,
    label_english: "Holy Spirit",
    aggregation_level2: "Holy Spirit",
    aggregation_level1: "God",
  },
  {
    id: 40,
    label_czech: "Narození Páně",
    label_czech_2: null,
    label_english: "Nativity of Christ",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 45,
    label_czech: "Zmrtvýchvstání Páně",
    label_czech_2: null,
    label_english: "Resurrection of the Lord",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 37,
    label_czech: "Božské Srdce Páně",
    label_czech_2: null,
    label_english: "Sacred Heart Church",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 44,
    label_czech: "sv. Salvátor",
    label_czech_2: null,
    label_english: "St. Salvator",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 38,
    label_czech: "Nejsvětější Srdce Páně",
    label_czech_2: null,
    label_english: "The Most Sacred Heart Church",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 42,
    label_czech: "Proměnění Páně",
    label_czech_2: null,
    label_english: "Transfiguration of Jesus",
    aggregation_level2: "Christ",
    aggregation_level1: "God",
  },
  {
    id: 41,
    label_czech: "Nejsvětější Trojice",
    label_czech_2: null,
    label_english: "Trinity",
    aggregation_level2: "God",
    aggregation_level1: "God",
  },
  {
    id: 144,
    label_czech: "sv. Rodina",
    label_czech_2: null,
    label_english: "Holy Family",
    aggregation_level2: "Holy Family",
    aggregation_level1: "Holy Family",
  },
  {
    id: 51,
    label_czech: "Povýšení sv. Kříže",
    label_czech_2: null,
    label_english: "Exaltation of the Holy Cross",
    aggregation_level2: "Holy Cross",
    aggregation_level1: "holy object",
  },
  {
    id: 50,
    label_czech: "Nalezení sv. Kříže",
    label_czech_2: null,
    label_english: "Finding of the Cross",
    aggregation_level2: "Holy Cross",
    aggregation_level1: "holy object",
  },
  {
    id: 52,
    label_czech: "sv. Kříž",
    label_czech_2: "sv. Kříž Větší",
    label_english: "Holy Cross",
    aggregation_level2: "Holy Cross",
    aggregation_level1: "holy object",
  },
  {
    id: 54,
    label_czech: "svaté schody",
    label_czech_2: null,
    label_english: "Holy Stairs",
    aggregation_level2: "holy object",
    aggregation_level1: "holy object",
  },
  {
    id: 34,
    label_czech: "Zvěstování Panně Marii",
    label_czech_2: "Zvěstování Panny Marie",
    label_english: "Annunciation of Our Lady",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 46,
    label_czech: "Zvěstování Páně",
    label_czech_2: null,
    label_english: "Annunciation of the Lord",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 4,
    label_czech: "Nanebevzetí Panny Marie",
    label_czech_2: null,
    label_english: "Assumption of the Virgin Mary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 10,
    label_czech: "Neposkvrněné početí Panny Marie",
    label_czech_2: null,
    label_english: "Immaculate Conception",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 2,
    label_czech: "Loreta",
    label_czech_2: null,
    label_english: "Loreta",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 3,
    label_czech: "Matka Boží",
    label_czech_2: null,
    label_english: "Mother of God",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 11,
    label_czech: "Matka Boží Loretánská",
    label_czech_2: null,
    label_english: "Mother of God of Loreto",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 1,
    label_czech: "Jméno Panny Marie",
    label_czech_2: null,
    label_english: "Name of the Virgin Mary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 5,
    label_czech: "Narození Panny Marie",
    label_czech_2: null,
    label_english: "Nativity of the Blessed Virgin Mary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 25,
    label_czech: "Panna Maria pod řetězem konce mosta",
    label_czech_2: null,
    label_english: "Our Lady beneath the Chain",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 26,
    label_czech: "Panna Maria Pomocná",
    label_czech_2: "Panna Maria Pomocnice křestanů",
    label_english: "Our Lady Help of Christians",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 23,
    label_czech: "Panna Maria Neposkvrněná",
    label_czech_2: null,
    label_english: "Our Lady Immaculate",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 15,
    label_czech: "Panna Maria Altöttingská",
    label_czech_2: null,
    label_english: "Our Lady of Altötting",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 30,
    label_czech: "Panna Maria Utěšitelka",
    label_czech_2: null,
    label_english: "Our Lady of Consolation",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 31,
    label_czech: "Panna Maria Uzdravení nemocných",
    label_czech_2: null,
    label_english: "Our Lady of Healing",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 12,
    label_czech: "Panna Maria Loretánská",
    label_czech_2: null,
    label_english: "Our Lady of Loreto",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 19,
    label_czech: "Panna Maria Karmelská",
    label_czech_2: null,
    label_english: "Our Lady of Mount Carmel",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 21,
    label_czech: "Panna Maria Královna Míru",
    label_czech_2: null,
    label_english: "Our Lady of Peace",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 27,
    label_czech: "Panna Maria Ustavičné pomoci",
    label_czech_2: null,
    label_english: "Our Lady of Perpetual Help",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 17,
    label_czech: "Panna Maria Bolestná",
    label_czech_2: null,
    label_english: "Our Lady of Sorrows",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 28,
    label_czech: "Panna Maria Růžencová",
    label_czech_2: null,
    label_english: "Our Lady of the Rosary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 18,
    label_czech: "Panna Maria Sedmibolestná",
    label_czech_2: null,
    label_english: "Our Lady of the Seven Sorrows",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 32,
    label_czech: "Panna Maria Vítězná",
    label_czech_2: null,
    label_english: "Our Lady of Victories",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 22,
    label_czech: "Panna Maria na písku",
    label_czech_2: null,
    label_english: "Our Lady on the Sand",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 20,
    label_czech: "Panna Maria Královna andělů",
    label_czech_2: null,
    label_english: "Our Lady Queen of the Angels",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 24,
    label_czech: "Panna Maria pod ochranou Božské Prozřetelnosti",
    label_czech_2: null,
    label_english: "Our Lady under the protection of Divine Providence",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 8,
    label_czech: "Nejsvětější Rodička Boží Maria",
    label_czech_2: null,
    label_english: "Our Most Holy Lady Theotokos",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 13,
    label_czech: "Obětování Panny Marie",
    label_czech_2: null,
    label_english: "Sacrifice of the Virgin Mary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 16,
    label_czech: "Panna Maria Andělská",
    label_czech_2: null,
    label_english: "Saint Mary of the Angels",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 29,
    label_czech: "Panna Maria Sněžná",
    label_czech_2: null,
    label_english: "Saint Mary of the Snows",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 33,
    label_czech: "Zasnoubení Panny Marie",
    label_czech_2: null,
    label_english: "The Betrothal of the Virgin Mary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 14,
    label_czech: "Panna Maria",
    label_czech_2: null,
    label_english: "Virgin Mary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 9,
    label_czech: "Panna Maria Bohorodička",
    label_czech_2: null,
    label_english: "Virgin Mary Theotokos",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 6,
    label_czech: "Navštívení Panny Marie",
    label_czech_2: null,
    label_english: "Visitation of the Virgin Mary",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 7,
    label_czech: "Navštívení Panny Marie u sv. Alžběty v horách",
    label_czech_2: null,
    label_english:
      "Visitation of the Virgin Mary at St. Elizabeth in the Mountains",
    aggregation_level2: "Mary",
    aggregation_level1: "Mary",
  },
  {
    id: 55,
    label_czech: "Všech svatých",
    label_czech_2: null,
    label_english: "All Saints",
    aggregation_level2: "group of saints",
    aggregation_level1: "saint",
  },
  {
    id: 53,
    label_czech: "Čtrnáct svatých pomocníků",
    label_czech_2: null,
    label_english: "Fourteen Holy Helpers",
    aggregation_level2: "group of saints",
    aggregation_level1: "saint",
  },
  {
    id: 68,
    label_czech: "bl. Juliána Collalti",
    label_czech_2: null,
    label_english: "Giuliana of Collato",
    aggregation_level2: "Giuliana of Collato",
    aggregation_level1: "saint",
  },
  {
    id: 56,
    label_czech: "Svatí patroni čeští",
    label_czech_2: null,
    label_english: "Patron Saints of Bohemia",
    aggregation_level2: "group of saints",
    aggregation_level1: "saint",
  },
  {
    id: 58,
    label_czech: "Sv. Cyril a Metoděj",
    label_czech_2: null,
    label_english: "Ss. Cyril and Methodius",
    aggregation_level2: "Ss. Cyril and Methodius",
    aggregation_level1: "saint",
  },
  {
    id: 94,
    label_czech: "sv. Filip a Jakub",
    label_czech_2: null,
    label_english: "Ss. Philip and James",
    aggregation_level2: "Ss. Philip and James",
    aggregation_level1: "saint",
  },
  {
    id: 148,
    label_czech: "sv. Šimon a Juda",
    label_czech_2: null,
    label_english: "Ss. Simon the Zealot and Jude",
    aggregation_level2: "Ss. Simon the Zealot and Jude",
    aggregation_level1: "saint",
  },
  {
    id: 63,
    label_czech: "sv. Vojtěch",
    label_czech_2: null,
    label_english: "St. Adalbert of Prague",
    aggregation_level2: "St. Adalbert of Prague",
    aggregation_level1: "saint",
  },
  {
    id: 57,
    label_czech: "sv. Anežka",
    label_czech_2: null,
    label_english: "St. Agnes of Bohemia",
    aggregation_level2: "St. Agnes of Bohemia",
    aggregation_level1: "saint",
  },
  {
    id: 74,
    label_czech: "sv. Anežka Římská",
    label_czech_2: null,
    label_english: "St. Agnes of Rome",
    aggregation_level2: "St. Agnes of Rome",
    aggregation_level1: "saint",
  },
  {
    id: 70,
    label_czech: "sv. Alexius",
    label_czech_2: null,
    label_english: "St. Alexius",
    aggregation_level2: "St. Alexius",
    aggregation_level1: "saint",
  },
  {
    id: 71,
    label_czech: "sv. Alfons z Liguori",
    label_czech_2: null,
    label_english: "St. Alphonsus Liguori",
    aggregation_level2: "St. Alphonsus Liguori",
    aggregation_level1: "saint",
  },
  {
    id: 73,
    label_czech: "sv. Ambrož",
    label_czech_2: null,
    label_english: "St. Ambrose",
    aggregation_level2: "St. Ambrose",
    aggregation_level1: "saint",
  },
  {
    id: 140,
    label_czech: "sv. Ondřej",
    label_czech_2: null,
    label_english: "St. Andrew",
    aggregation_level2: "St. Andrew",
    aggregation_level1: "saint",
  },
  {
    id: 75,
    label_czech: "sv. Anna",
    label_czech_2: null,
    label_english: "St. Anne",
    aggregation_level2: "St. Anne",
    aggregation_level1: "saint",
  },
  {
    id: 76,
    label_czech: "sv. Antonín",
    label_czech_2: null,
    label_english: "St. Anthony",
    aggregation_level2: "St. Anthony",
    aggregation_level1: "saint",
  },
  {
    id: 77,
    label_czech: "sv. Antonín Paduánský",
    label_czech_2: null,
    label_english: "St. Anthony of Padua",
    aggregation_level2: "St. Anthony of Padua",
    aggregation_level1: "saint",
  },
  {
    id: 78,
    label_czech: "sv. Apolinář",
    label_czech_2: null,
    label_english: "St. Apollinaris of Ravenna",
    aggregation_level2: "St. Apollinaris of Ravenna",
    aggregation_level1: "saint",
  },
  {
    id: 79,
    label_czech: "sv. Augustin",
    label_czech_2: null,
    label_english: "St. Augustine of Hippo",
    aggregation_level2: "St. Augustine of Hippo",
    aggregation_level1: "saint",
  },
  {
    id: 80,
    label_czech: "sv. Barbora",
    label_czech_2: null,
    label_english: "St. Barbara",
    aggregation_level2: "St. Barbara",
    aggregation_level1: "saint",
  },
  {
    id: 81,
    label_czech: "sv. Bartoloměj",
    label_czech_2: null,
    label_english: "St. Bartholomew",
    aggregation_level2: "St. Bartholomew",
    aggregation_level1: "saint",
  },
  {
    id: 82,
    label_czech: "sv. Benedikt",
    label_czech_2: null,
    label_english: "St. Benedict",
    aggregation_level2: "St. Benedict",
    aggregation_level1: "saint",
  },
  {
    id: 83,
    label_czech: "sv. Bernard",
    label_czech_2: null,
    label_english: "St. Bernard",
    aggregation_level2: "St. Bernard",
    aggregation_level1: "saint",
  },
  {
    id: 84,
    label_czech: "sv. Bernardin",
    label_czech_2: null,
    label_english: "St. Bernardino",
    aggregation_level2: "St. Bernardino",
    aggregation_level1: "saint",
  },
  {
    id: 85,
    label_czech: "sv. Bernardin Sienský",
    label_czech_2: null,
    label_english: "St. Bernardino of Siena",
    aggregation_level2: "St. Bernardino of Siena",
    aggregation_level1: "saint",
  },
  {
    id: 86,
    label_czech: "sv. Bonaventura",
    label_czech_2: null,
    label_english: "St. Bonaventure",
    aggregation_level2: "St. Bonaventure",
    aggregation_level1: "saint",
  },
  {
    id: 87,
    label_czech: "sv. Bonifác",
    label_czech_2: null,
    label_english: "St. Boniface",
    aggregation_level2: "St. Boniface",
    aggregation_level1: "saint",
  },
  {
    id: 88,
    label_czech: "sv. Bruno",
    label_czech_2: null,
    label_english: "St. Bruno",
    aggregation_level2: "St. Bruno",
    aggregation_level1: "saint",
  },
  {
    id: 118,
    label_czech: "sv. Kajetán",
    label_czech_2: null,
    label_english: "St. Cajetan",
    aggregation_level2: "St. Cajetan",
    aggregation_level1: "saint",
  },
  {
    id: 100,
    label_czech: "sv. Haštal",
    label_czech_2: null,
    label_english: "St. Castulus",
    aggregation_level2: "St. Castulus",
    aggregation_level1: "saint",
  },
  {
    id: 121,
    label_czech: "sv. Kateřina",
    label_czech_2: null,
    label_english: "St. Catherine",
    aggregation_level2: "St. Catherine",
    aggregation_level1: "saint",
  },
  {
    id: 123,
    label_czech: "sv. Klement Maria Hofbauer",
    label_czech_2: null,
    label_english: "St. Clement Mary Hofbauer",
    aggregation_level2: "St. Clement Mary Hofbauer",
    aggregation_level1: "saint",
  },
  {
    id: 65,
    label_czech: "sv. Kliment",
    label_czech_2: null,
    label_english: "St. Clement of Rome",
    aggregation_level2: "St. Clement of Rome",
    aggregation_level1: "saint",
  },
  {
    id: 124,
    label_czech: "sv. Kunhuta",
    label_czech_2: null,
    label_english: "St. Cunigunde of Luxembourg",
    aggregation_level2: "St. Cunigunde of Luxembourg",
    aggregation_level1: "saint",
  },
  {
    id: 89,
    label_czech: "sv. Dionysius z Paříže",
    label_czech_2: null,
    label_english: "St. Denis of Paris",
    aggregation_level2: "St. Denis of Paris",
    aggregation_level1: "saint",
  },
  {
    id: 90,
    label_czech: "sv. Dominik",
    label_czech_2: null,
    label_english: "St. Dominic",
    aggregation_level2: "St. Dominic",
    aggregation_level1: "saint",
  },
  {
    id: 72,
    label_czech: "sv. Alžběta",
    label_czech_2: null,
    label_english: "St. Elisabeth",
    aggregation_level2: "St. Elisabeth",
    aggregation_level1: "saint",
  },
  {
    id: 91,
    label_czech: "sv. Fabián",
    label_czech_2: null,
    label_english: "St. Fabian",
    aggregation_level2: "St. Fabian",
    aggregation_level1: "saint",
  },
  {
    id: 92,
    label_czech: "sv. Faustyna",
    label_czech_2: null,
    label_english: "St. Faustina Kowalska",
    aggregation_level2: "St. Faustina Kowalska",
    aggregation_level1: "saint",
  },
  {
    id: 93,
    label_czech: "sv. Felix z Cantalice",
    label_czech_2: null,
    label_english: "St. Felix of Cantalice",
    aggregation_level2: "St. Felix of Cantalice",
    aggregation_level1: "saint",
  },
  {
    id: 95,
    label_czech: "sv. František",
    label_czech_2: null,
    label_english: "St. Francis",
    aggregation_level2: "St. Francis",
    aggregation_level1: "saint",
  },
  {
    id: 98,
    label_czech: "sv. František z Pauly",
    label_czech_2: null,
    label_english: "St. Francis of Paola",
    aggregation_level2: "St. Francis of Paola",
    aggregation_level1: "saint",
  },
  {
    id: 96,
    label_czech: "sv. František Serafínský",
    label_czech_2: null,
    label_english: "St. Francis of Seraphim",
    aggregation_level2: "St. Francis of Seraphim",
    aggregation_level1: "saint",
  },
  {
    id: 97,
    label_czech: "sv. František Xaverský",
    label_czech_2: null,
    label_english: "St. Francis Xavier",
    aggregation_level2: "St. Francis Xavier",
    aggregation_level1: "saint",
  },
  {
    id: 101,
    label_czech: "sv. Havel",
    label_czech_2: null,
    label_english: "St. Gall",
    aggregation_level2: "St. Gall",
    aggregation_level1: "saint",
  },
  {
    id: 166,
    label_czech: "sv. Jiří",
    label_czech_2: null,
    label_english: "St. George",
    aggregation_level2: "St. George",
    aggregation_level1: "saint",
  },
  {
    id: 114,
    label_czech: "sv. Jiljí",
    label_czech_2: null,
    label_english: "St. Giles",
    aggregation_level2: "St. Giles",
    aggregation_level1: "saint",
  },
  {
    id: 99,
    label_czech: "sv. Gotthard",
    label_czech_2: null,
    label_english: "St. Gotthard",
    aggregation_level2: "St. Gotthard",
    aggregation_level1: "saint",
  },
  {
    id: 102,
    label_czech: "sv. Hedvika Slezská",
    label_czech_2: null,
    label_english: "St. Hedwig of Silesia",
    aggregation_level2: "St. Hedwig of Silesia",
    aggregation_level1: "saint",
  },
  {
    id: 103,
    label_czech: "sv. Hypolit",
    label_czech_2: null,
    label_english: "St. Hypolitus",
    aggregation_level2: "St. Hypolitus",
    aggregation_level1: "saint",
  },
  {
    id: 120,
    label_czech: "sv. Karel Veliký",
    label_czech_2: null,
    label_english: "St. Charlemagne",
    aggregation_level2: "St. Charlemagne",
    aggregation_level1: "saint",
  },
  {
    id: 119,
    label_czech: "sv. Karel Boromejský",
    label_czech_2: null,
    label_english: "St. Charles Borromeo",
    aggregation_level2: "St. Charles Borromeo",
    aggregation_level1: "saint",
  },
  {
    id: 104,
    label_czech: "sv. Ignác",
    label_czech_2: null,
    label_english: "St. Ignatius of Loyola",
    aggregation_level2: "St. Ignatius of Loyola",
    aggregation_level1: "saint",
  },
  {
    id: 105,
    label_czech: "sv. Ivan Poustevník",
    label_czech_2: null,
    label_english: "St. Ivan the Hermit",
    aggregation_level2: "St. Ivan the Hermit",
    aggregation_level1: "saint",
  },
  {
    id: 106,
    label_czech: "sv. Jakub",
    label_czech_2: null,
    label_english: "St. James",
    aggregation_level2: "St. James",
    aggregation_level1: "saint",
  },
  {
    id: 107,
    label_czech: "sv. Jakub Starší",
    label_czech_2: null,
    label_english: "St. James the Elder",
    aggregation_level2: "St. James the Elder",
    aggregation_level1: "saint",
  },
  {
    id: 108,
    label_czech: "sv. Jakub Větší",
    label_czech_2: null,
    label_english: "St. James the Great",
    aggregation_level2: "St. James the Great",
    aggregation_level1: "saint",
  },
  {
    id: 113,
    label_czech: "sv. Jeroným",
    label_czech_2: null,
    label_english: "St. Jerome",
    aggregation_level2: "St. Jerome",
    aggregation_level1: "saint",
  },
  {
    id: 112,
    label_czech: "sv. Jan Zlatoústý",
    label_czech_2: null,
    label_english: "St. John Chrysostom",
    aggregation_level2: "St. John Chrysostom",
    aggregation_level1: "saint",
  },
  {
    id: 59,
    label_czech: "sv. Jan Nepomucký",
    label_czech_2: null,
    label_english: "St. John of Nepomuk",
    aggregation_level2: "St. John of Nepomuk",
    aggregation_level1: "saint",
  },
  {
    id: 115,
    label_czech: "sv. John Ogilvie",
    label_czech_2: null,
    label_english: "St. John Ogilvie",
    aggregation_level2: "St. John Ogilvie",
    aggregation_level1: "saint",
  },
  {
    id: 110,
    label_czech: "sv. Jan Křtitel",
    label_czech_2: null,
    label_english: "St. John the Baptist",
    aggregation_level2: "St. John the Baptist",
    aggregation_level1: "saint",
  },
  {
    id: 111,
    label_czech: "sv. Jan Křtitel na poušti",
    label_czech_2: null,
    label_english: "St. John the Baptist in the desert",
    aggregation_level2: "St. John the Baptist in the desert",
    aggregation_level1: "saint",
  },
  {
    id: 109,
    label_czech: "sv. Jan Evangelista",
    label_czech_2: null,
    label_english: "St. John the Evangelist",
    aggregation_level2: "St. John the Evangelist",
    aggregation_level1: "saint",
  },
  {
    id: 116,
    label_czech: "sv. Josef",
    label_czech_2: null,
    label_english: "St. Joseph",
    aggregation_level2: "St. Joseph",
    aggregation_level1: "saint",
  },
  {
    id: 117,
    label_czech: "sv. Josef Kalasanský",
    label_czech_2: null,
    label_english: "St. Joseph Calasanz",
    aggregation_level2: "St. Joseph Calasanz",
    aggregation_level1: "saint",
  },
  {
    id: 122,
    label_czech: "sv. Kilián",
    label_czech_2: null,
    label_english: "St. Kilian",
    aggregation_level2: "St. Kilian",
    aggregation_level1: "saint",
  },
  {
    id: 155,
    label_czech: "sv. Vavřinec",
    label_czech_2: null,
    label_english: "St. Lawrence",
    aggregation_level2: "St. Lawrence",
    aggregation_level1: "saint",
  },
  {
    id: 125,
    label_czech: "sv. Lazar",
    label_czech_2: null,
    label_english: "St. Lazarus of Bethany",
    aggregation_level2: "St. Lazarus of Bethany",
    aggregation_level1: "saint",
  },
  {
    id: 127,
    label_czech: "sv. Linhart",
    label_czech_2: null,
    label_english: "St. Leonard",
    aggregation_level2: "St. Leonard",
    aggregation_level1: "saint",
  },
  {
    id: 126,
    label_czech: "sv. Leopold",
    label_czech_2: null,
    label_english: "St. Leopold",
    aggregation_level2: "St. Leopold",
    aggregation_level1: "saint",
  },
  {
    id: 60,
    label_czech: "sv. Ludmila",
    label_czech_2: null,
    label_english: "St. Ludmila of Bohemia",
    aggregation_level2: "St. Ludmila of Bohemia",
    aggregation_level1: "saint",
  },
  {
    id: 129,
    label_czech: "sv. Markéta",
    label_czech_2: null,
    label_english: "St. Margaret",
    aggregation_level2: "St. Margaret",
    aggregation_level1: "saint",
  },
  {
    id: 128,
    label_czech: "sv. Marek",
    label_czech_2: null,
    label_english: "St. Mark",
    aggregation_level2: "St. Mark",
    aggregation_level1: "saint",
  },
  {
    id: 130,
    label_czech: "sv. Martin",
    label_czech_2: null,
    label_english: "St. Martin",
    aggregation_level2: "St. Martin",
    aggregation_level1: "saint",
  },
  {
    id: 131,
    label_czech: "sv. Máří Magdalena",
    label_czech_2: null,
    label_english: "St. Mary Magdalene",
    aggregation_level2: "St. Mary Magdalene",
    aggregation_level1: "saint",
  },
  {
    id: 133,
    label_czech: "sv. Materna",
    label_czech_2: null,
    label_english: "St. Maternus",
    aggregation_level2: "St. Maternus",
    aggregation_level1: "saint",
  },
  {
    id: 134,
    label_czech: "sv. Matouš",
    label_czech_2: null,
    label_english: "St. Matthew",
    aggregation_level2: "St. Matthew",
    aggregation_level1: "saint",
  },
  {
    id: 135,
    label_czech: "sv. Matouš Evangelista",
    label_czech_2: null,
    label_english: "St. Matthew the Evangelist",
    aggregation_level2: "St. Matthew the Evangelist",
    aggregation_level1: "saint",
  },
  {
    id: 132,
    label_czech: "sv. Matěj",
    label_czech_2: null,
    label_english: "St. Matthias",
    aggregation_level2: "St. Matthias",
    aggregation_level1: "saint",
  },
  {
    id: 136,
    label_czech: "sv. Michael",
    label_czech_2: "sv. Michal",
    label_english: "St. Michael",
    aggregation_level2: "St. Michael",
    aggregation_level1: "saint",
  },
  {
    id: 139,
    label_czech: "sv. Modest",
    label_czech_2: null,
    label_english: "St. Modestus",
    aggregation_level2: "St. Modestus",
    aggregation_level1: "saint",
  },
  {
    id: 137,
    label_czech: "sv. Mikuláš",
    label_czech_2: null,
    label_english: "St. Nicholas",
    aggregation_level2: "St. Nicholas",
    aggregation_level1: "saint",
  },
  {
    id: 138,
    label_czech: "sv. Mikuláš Tolentinský",
    label_czech_2: null,
    label_english: "St. Nicholas of Tolentino",
    aggregation_level2: "St. Nicholas of Tolentino",
    aggregation_level1: "saint",
  },
  {
    id: 66,
    label_czech: "sv. Norbert",
    label_czech_2: null,
    label_english: "St. Norbert of Xanten",
    aggregation_level2: "St. Norbert of Xanten",
    aggregation_level1: "saint",
  },
  {
    id: 141,
    label_czech: "sv. Pavel",
    label_czech_2: "Pavel",
    label_english: "St. Paul",
    aggregation_level2: "St. Paul",
    aggregation_level1: "saint",
  },
  {
    id: 142,
    label_czech: "sv. Petr",
    label_czech_2: null,
    label_english: "St. Peter",
    aggregation_level2: "St. Peter",
    aggregation_level1: "saint",
  },
  {
    id: 143,
    label_czech: "sv. Petr Celestin",
    label_czech_2: null,
    label_english: "St. Peter Celestine",
    aggregation_level2: "St. Peter Celestine",
    aggregation_level1: "saint",
  },
  {
    id: 67,
    label_czech: "sv. Prokop",
    label_czech_2: null,
    label_english: "St. Procopius of Sázava",
    aggregation_level2: "St. Procopius of Sázava",
    aggregation_level1: "saint",
  },
  {
    id: 145,
    label_czech: "sv. Roch",
    label_czech_2: null,
    label_english: "St. Roch",
    aggregation_level2: "St. Roch",
    aggregation_level1: "saint",
  },
  {
    id: 146,
    label_czech: "sv. Rosalie",
    label_czech_2: null,
    label_english: "St. Rosalia",
    aggregation_level2: "St. Rosalia",
    aggregation_level1: "saint",
  },
  {
    id: 147,
    label_czech: "sv. Šebestián",
    label_czech_2: null,
    label_english: "St. Sebastian",
    aggregation_level2: "St. Sebastian",
    aggregation_level1: "saint",
  },
  {
    id: 158,
    label_czech: "sv. Zikmund",
    label_czech_2: null,
    label_english: "St. Sigismund",
    aggregation_level2: "St. Sigismund",
    aggregation_level1: "saint",
  },
  {
    id: 149,
    label_czech: "sv. Štěpán",
    label_czech_2: null,
    label_english: "St. Stephen ",
    aggregation_level2: "St. Stephen ",
    aggregation_level1: "saint",
  },
  {
    id: 150,
    label_czech: "sv. Štěpán Prvomučedník",
    label_czech_2: null,
    label_english: "St. Stephen Protomartyr",
    aggregation_level2: "St. Stephen Protomartyr",
    aggregation_level1: "saint",
  },
  {
    id: 151,
    label_czech: "sv. Teresie od Dítěte Ježíše a od Svaté Tváře",
    label_czech_2: null,
    label_english: "St. Therese of the Child Jesus and the Holy Face",
    aggregation_level2: "St. Therese of the Child Jesus and the Holy Face",
    aggregation_level1: "saint",
  },
  {
    id: 152,
    label_czech: "sv. Tomáš",
    label_czech_2: null,
    label_english: "St. Thomas",
    aggregation_level2: "St. Thomas",
    aggregation_level1: "saint",
  },
  {
    id: 154,
    label_czech: "sv. Valentin",
    label_czech_2: null,
    label_english: "St. Valentine",
    aggregation_level2: "St. Valentine",
    aggregation_level1: "saint",
  },
  {
    id: 157,
    label_czech: "sv. Vincent z Pauly",
    label_czech_2: null,
    label_english: "St. Vincent de Paul",
    aggregation_level2: "St. Vincent de Paul",
    aggregation_level1: "saint",
  },
  {
    id: 62,
    label_czech: "sv. Vít",
    label_czech_2: null,
    label_english: "St. Vitus",
    aggregation_level2: "St. Vitus",
    aggregation_level1: "saint",
  },
  {
    id: 61,
    label_czech: "sv. Václav",
    label_czech_2: null,
    label_english: "St. Wenceslaus",
    aggregation_level2: "St. Wenceslaus",
    aggregation_level1: "saint",
  },
  {
    id: 156,
    label_czech: "sv. Vilém",
    label_czech_2: null,
    label_english: "St. William",
    aggregation_level2: "St. William",
    aggregation_level1: "saint",
  },
  {
    id: 64,
    label_czech: "sv. Zdislava",
    label_czech_2: null,
    label_english: "St. Zdislava of Lemberk",
    aggregation_level2: "St. Zdislava of Lemberk",
    aggregation_level1: "saint",
  },
  {
    id: 69,
    label_czech: "Stigmatizace sv. Františka",
    label_czech_2: null,
    label_english: "Stigmata of St. Francis",
    aggregation_level2: "St. Francis",
    aggregation_level1: "saint",
  },
  {
    id: 153,
    label_czech: "sv. Tři králové",
    label_czech_2: null,
    label_english: "The Magi",
    aggregation_level2: "The Magi",
    aggregation_level1: "saint",
  },
];
